<ntap-view-window
  #childWindow
  target="noviRegistriraniKorisnikItem"
  [contentTemplate]="viewWindowContent"
>
  <ng-template #viewWindowContent let-defaultTemplate>
    <ng-container ntapDynamicFormProvider>
      <ntap-prime-popupview appendTo="body" [modal]="true">
        <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
      </ntap-prime-popupview>
    </ng-container>
  </ng-template>
</ntap-view-window>
<p-button
  ntapDebounceClick
  label="Otvori"
  (onClick)="executeAction($event)"
  [disabled]="(isDisabled$ | async) ?? true"
></p-button>
